export const genderList = [
  {
    key: "Male",
    value: "male",
  },
  {
    key: "Female",
    value: "female",
  },
  {
    key: "Two-Spirit",
    value: "two-spirit",
  },
  {
    key: "Non-Binary",
    value: "non-binary",
  },
  {
    key: "Genderfluid",
    value: "genderfluid",
  },
  {
    key: "Other",
    value: "other",
  },
];

export const ethnicityList = [
  { key: "Asian", value: "Asian" },
  { key: "Black/African Descent", value: "Black/African Descent" },
  { key: "Caribbean", value: "Caribbean" },
  { key: "East Asian/Pacific Islander", value: "East Asian/Pacific Islander" },
  { key: "European", value: "European" },
  { key: "Hispanic/Latinx", value: "Hispanic/Latinx" },
  { key: "Indigenous/Native American", value: "Indigenous/Native American" },
  { key: "Middle Eastern", value: "Middle Eastern" },
  { key: "White/Caucasian", value: "White/Caucasian" },
  { key: "other", value: "Other" },
];

export const filteredEthnicityList = [
  "Asian",
  "Black",
  "African Descent",
  "Black/African Descent",
  "African Descent/Black",
  "Caribbean",
  "East Asian",
  "Pacific Islander",
  "East Asian/Pacific Islander",
  "Pacific Islander/East Asian",
  "European",
  "Hispanic",
  "Latinx",
  "Hispanic/Latinx",
  "Latinx/Hispanic",
  "Indigenous",
  "Native American",
  "Indigenous/Native American",
  "Native American/Indigenous",
  "Middle Eastern",
  "White",
  "Caucasian",
  "White/Caucasian",
  "Caucasian/White",
  "Other",
];

export const languagesSpoken = [
  "English",
  "French",
  "Spanish",
  "Mandarin",
  "Cantonese",
  "Hindi",
  "Arabic",
  "Ukrainian",
  "Turkish",
  "Swahili",
  "Other",
];

export const employmentStatusList = [
  "Employed Full-Time",
  "Employed Part-Time",
  "Self-Employed",
  "Unemployed",
  "Student",
  "Retired",
  "Freelancer/Contractor",
  "Seeking Employment",
  "Homemaker",
];

export const menteeAreaOfInterest = [
  "Aerospace",
  "Air Traffic Services",
  "Aircraft De-Icer",
  "Aircraft Fueler",
  "Aircraft Maintenance",
  "Airport Operations",
  "Airworthiness / Quality Assurance",
  "Aviation Management / Consultants",
  "Aviation Non-Profits",
  "Aviation Safety",
  "Aviation Sales or Insurance",
  "Aviation Security and Passenger Screening",
  "Cargo Sales",
  "Customer Service Agent",
  "Data Science & Analytics",
  "Drone / RPAS",
  "Engineer",
  "Flight Attendant",
  "Flight Operations",
  "Human Resources",
  "IT & Technology",
  "Maintenance Technician",
  "Pilot (Fixed-Wing)",
  "Pilot (Helicopter/Rotary)",
  "Ramp Agent",
  "RCAF",
];

export const menteeDesiredSpecialization = [
  "Air Traffic Services",
  "Pilot Licenses/Ratings",
  "Pilot Careers",
  "Aircraft Maintenance Engineer",
  "Aerospace",
  "Data Science",
  "RCAF",
  "Air Traffic Controller - En route",
  "Air Traffic Controller - Terminal",
  "Air Traffic Controller - Tower",
  "Flight Service Specialist (Tower)",
  "Flight Service Specialist (FIC)",
];

export const roleProfile = (role) => {
  if (role === "mentee") {
    return "menteeProfile";
  } else if (role === "mentor") {
    return "mentorProfile";
  } else if (role === "mentee_mentor") {
    return "menteeMentorProfile";
  } else if (role === "sponsor") {
    return "sponsorProfile";
  }
};
export const sponsorsModalList = {
  "one-year essentials plan": [
    "Showcase your insights and company values to make a lasting impression.",
    "Upload up to 4 videos or presentations annually to elevate your brand.",
    "Upload up to 4 articles or blogs annually to highlight your organizational expertise.",
    "Put your organization on the radar of aviation professionals across the industry! ",
  ],
  "one-year premium plan": [
    "Showcase your insights and company values to make a lasting impression.",
    "Upload up to 4 videos or presentations annually to elevate your brand.",
    "Upload up to 4 articles or blogs annually to highlight your organizational expertise.",
    "Put your organization on the radar of aviation professionals across the industry! ",
  ],
  "echo access pass": [],
};
export const featureList = {
  mentee: {
    free: [
      [
        { text: "1 mentor connection", bold: true },
        { text: " for personalized advice" },
      ],
      [
        { text: "Access" },
        { text: " free", bold: true },
        { text: " learn content and " },
        { text: "purchase", bold: true },
        { text: " courses, webinars, & virtual events individually" },
      ],
    ],
    "echo explore": [
      [
        { text: "1 mentor connection", bold: true },
        { text: " for personalized advice" },
      ],
      [
        { text: "Unlimited access", bold: true },
        {
          text: " to professional development content, including courses, webinars, virtual events, videos, presentations, and articles. No additional purchase required",
        },
      ],
    ],
    "echo excel": [
      [
        { text: "Up to 5 mentor connections", bold: true },
        { text: " at once for diverse insights, guidance, and expertise" },
      ],
      [
        { text: "Unlimited access", bold: true },
        {
          text: " to professional development content, including courses, webinars, virtual events, videos, presentations, and articles. No additional purchase required",
        },
      ],
    ],
  },

  mentor: {
    free: [
      [
        { text: "Mentor others", bold: true },
        { text: " - Share your expertise & gain leadership experience" },
      ],
      [
        { text: "Access free", bold: true },
        { text: " learn content and " },
        { text: "purchase", bold: true },
        { text: " courses, webinars, & virtual events individually" },
      ],
    ],
    "echo explore": [
      [
        { text: "Mentor others", bold: true },
        { text: " - Share your expertise & gain leadership experience" },
      ],
      [
        { text: "Unlimited access", bold: true },
        {
          text: " to professional development content, including courses, webinars, virtual events, videos, presentations, and articles. No additional purchase required",
        },
      ],
    ],
  },

  mentee_mentor: {
    free: [
      [
        { text: "1 mentor connection", bold: true },
        { text: " for personalized advice" },
      ],
      [
        { text: "Mentor others", bold: true },
        { text: " - Share your expertise & gain leadership experience" },
      ],
      [
        { text: "Access free", bold: true },
        { text: " learn content and " },
        { text: "purchase", bold: true },
        { text: " courses, webinars, & virtual events individually" },
      ],
    ],
    "echo explore": [
      [
        { text: "1 mentor connection", bold: true },
        { text: " for personalized advice" },
      ],
      [
        { text: "Mentor others", bold: true },
        { text: " - Share your expertise & gain leadership experience" },
      ],
      [
        { text: "Unlimited access", bold: true },
        {
          text: " to professional development content, including courses, webinars, virtual events, videos, presentations, and articles. No additional purchase required",
        },
      ],
    ],
    "echo excel": [
      [
        { text: "Up to 5 mentor connections", bold: true },
        { text: " at once for diverse insights, guidance, and expertise" },
      ],
      [
        { text: "Mentor others", bold: true },
        { text: " - Share your expertise & gain leadership experience" },
      ],
      [
        { text: "Unlimited access", bold: true },
        {
          text: " to professional development content, including courses, webinars, virtual events, videos, presentations, and articles. No additional purchase required",
        },
      ],
    ],
  },
  sponsor: {
    "one-year essentials plan": [
      [
        "",
        "Our annual essentials plan helps you amplify your presence and engage with the aviation industry on a deeper level",
      ],
      [
        "Put your organization on the radar",
        "with aviation professionals across the industry!",
      ],
      [
        "Host up to 2 webinars or virtual events per year",
        "to engage with the aviation community.",
      ],
      [
        "Showcase your insights and company values",
        "to make a lasting impression",
      ],
      [
        "Share up to 4 videos or presentations annually",
        "to elevate your brand.",
      ],
      [
        "Share up to 4 articles or blogs annually",
        "to highlight your organizational expertise",
      ],
    ],
    "one-year premium plan": [
      [
        "",
        "Take your impact to new heights with our premium plan, designed to boost your brand, showcase your industry insights, and connect with aviation professionals year-round!",
      ],
      [
        "Showcase your brand and make a lasting impact",
        "on aviation professionals.",
      ],
      [
        "Spark Industry Conversations",
        "through continuous engagement with echo’s vibrant community.",
      ],
      [
        "Full access to all professional development content",
        "in the learn section.",
      ],
      ["Host unlimited webinars and Virtual Events", "for maximum engagement."],
      [
        "Share unlimited videos and presentations",
        "to spotlight your expertise and company's values",
      ],
      [
        "Share unlimited articles and blogs",
        "to highlight your industry insights and achievements",
      ],
    ],
    "echo access pass": [
      [
        "",
        "Gain access to echo for 3 months and see how it can elevate your organization!",
      ],
      [
        "Host 1 webinar or virtual event",
        "to connect directly with both established and aspiring aviation professionals.",
      ],
      [
        `Share Your Organization's Voice:`,
        "Share up to 3 pieces of content—videos, presentations, articles, or blogs—to showcase your expertise within the aviation community!",
      ],
    ],
  },
};

export const subTitles = {
  mentee:
    "Thank you for joining us, we are thrilled to have you on board! To begin connecting with mentors, please download our mobile app and log in using the credentials you just created. You can explore professional development resources including courses, webinars, and more, both here and in the app. We are happy to support your journey toward a fulfilling aviation career! ",
  mentor: `Thank you for joining us, and for making a difference. Your experience and guidance help shape the future of aviation! We're thrilled to have you on board! To begin connecting with mentees, please download our mobile app and log in using the credentials you just created. You can explore professional development resources including courses, webinars, and more, both here and in the app. We are happy to be part of your aviation journey!`,
  mentee_mentor: `Thank you for joining us, and for making a difference. Your experience and guidance help shape the future of aviation! To begin connecting with mentors and mentees, please download our mobile app and log in using the credentials you just created. You can explore professional development resources including courses, webinars, and more, both here and in the app. We are happy to be part of your aviation journey!`,
};

export const employmentOptions = [
  "Employed Full-Time",
  "Employed Part-Time",
  "Self-Employed",
  "Unemployed",
  "Student",
  "Retired",
  "Freelancer/Contractor",
  "Seeking Employment",
  "Homemaker",
];

export const specializationList = [
  "Air Traffic Services",
  "Pilot Licenses/Ratings",
  "Pilot Careers",
  "Aircraft Maintenance",
  "Aerospace",
  "Data Science & Analytics",
  "IT & Technology",
  "RCAF",
  "Aviation Safety",
];

export const specializationSubList = [
  "Air Traffic Controller - En route",
  "Air Traffic Controller - Terminal",
  "Air Traffic Controller - Tower",
  "Flight Service Specialist (Tower)",
  "Flight Service Specialist (FIC)",
  "Aerobatic-Rated Pilot (Fixed-Wing)",
  "ATPL ",
  "CPL (Fixed-Wing)",
  "CPL (Rotary)",
  "IFR-Rated Pilot (Fixed-Wing)",
  "IFR-Rated Pilot (Rotary)",
  "Instructor-Rated Pilot (Fixed-Wing)",
  "Instructor-Rated Pilot (Rotary)",
  "Multi-Engine Rated Pilot (Fixed-Wing)",
  "Multi-IFR-Rated Pilot (Fixed-Wing)",
  "Night-Rated Pilot (Fixed-Wing)",
  "Night-Rated Pilot (Rotary)",
  "PPL (Fixed-Wing)",
  "PPL (Rotary)",
  "Agricultural Pilot",
  "Air Tour Pilot",
  "Airline Pilot",
  "Aircraft Sales Pilot",
  "Airshow Pilot",
  "Banner Towing Pilot",
  "Cargo Pilot",
  "Charter Pilot",
  "Contract Pilot",
  "Corporate/Business Pilot",
  "Drone Pilot",
  "Fire suppression pilot / Water Bomber",
  "Flight Instructor",
  "Glider Tow Pilot",
  "Government Service Pilot",
  "Jump Pilot (for skydivers)",
  "Law Enforcement Pilot",
  "Media and Patrol Pilot",
  "Medical and Air Ambulance Pilot",
  "Pilot Examiner",
  "Pipeline Patrol Pilot",
  "Test Pilot",
  "Structures focus",
  "Avionics focus",
  "Maintenance focus",
  "Aerospace Scientist",
  "Aerodynamics, Structures, and Controls Engineer",
  "Design Engineer",
  "Field Service Crew",
  "Systems Engineer",
  "Test and Evaluation Engineer",
  "Pilot training and simulator data",
  "Weather prediction data and forecasting",
  "Predictive aircraft maintenance data systems",
  "Flight and Airport Operations Optimization",
  "Passenger Experience, Safety, and Security",
  "Fleet and Asset Management",
  "Revenue Management, Logistics, and Pricing Optimization",
  "Aerospace Control Officer",
  "Aerospace Control Operator",
  "Aerospace Engineering Officer",
  "Aerospace Telecommunications and Information Systems Technician",
  "Air Combat Systems Officer",
  "Air Operations Officer",
  "Air Operations Support Technician",
  "Air Weapons Systems Technician",
  "Airborne Electronic Sensor Operator",
  "Airforce Pilot",
  "Aircraft Structures Technician",
  "Avionics Systems Technician",
  "Transport Canada Inspector",
  "Transport Safety Board",
  "Air Traffic Systems & Navigation Technology",
  "Aviation Cybersecurity & Data Protection",
  "Airport & Airline IT Systems",
  "Aviation Software Development & Integration",
];

export const desiredInterests = [
  "Pilot (Fixed-Wing)",
  "Pilot (Helicopter/Rotary)",
  "Air Traffic Services",
  "Aircraft Maintenance",
  "Aerospace",
  "Data Science & Analytics",
  "IT & Technology",
  "RCAF",
  "Aviation Safety",
];

export const formatEthnicity = (key, value) => {
  //console.log('value is', value)
  let filteredList;
  if (key === "key") {
    filteredList = ethnicityList.find((ethnicity) => ethnicity.key === value);
    if (!filteredList) {
      console.warn(`No matching category found for value: ${value}`);
      return ""; // Or return a default value
    }
    return filteredList.value;
  }

  if (key === "value") {
    filteredList = ethnicityList.find((ethnicity) => ethnicity.value === value);
    if (!filteredList) {
      console.warn(`No matching category found for value: ${value}`);
      return ""; // Or return a default value
    }
    return filteredList.key;
  }
};

export const formatGender = (value) => {
  const canonicalToLegacy = {
    woman: "female",
    man: "male",
    non_binary: "non-binary",
    two_spirit: "two-spirit",
    genderqueer_genderfluid: "genderfluid",
    another_identity: "other",
    prefer_not_to_say: "prefer not to say",
  };
  const filteredList = genderList.find(
    (gender) => gender.value === (canonicalToLegacy[value] ?? value),
  );
  return filteredList?.key ?? "Prefer not to say";
};

export const formatDisability = (value) => {
  if (value === "no") {
    return `No, I don't have a disability`;
  } else if (value === "yes") {
    return `Yes, I have a disability`;
  } else {
    return "Prefer not to say";
  }
};

export const formatCommunity = (value) => {
  if (value === "No") {
    return "No";
  } else if (value === "Yes") {
    return "Yes";
  } else {
    return "Prefer not to say";
  }
};
